<section class="rent-application-form">
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>
  @if (form) {
    <form class="rent-application-form__form astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-stack-m">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          <astral-select [control]="form.controls['rentalObjectCategory']" [itemsSource]="rentalObjectCategories"></astral-select>
          <astral-date-picker
            [control]="form.controls['applicationDate']"
            [label]="'RENT_APPLICATION.REGISTRATION_DATE'"
            [model]="dataContext.applicationDate"
            [isRequired]="true"
          ></astral-date-picker>
        </astral-layout-group>
      </section>
      @if (isNew) {
        <section class="astral-section-surface astral-stack-m">
          <app-information-block [text]="'RENT_APPLICATION.HELP_TEXT.SELECT_CONTACT'"></app-information-block>
          <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
            <astral-typeahead
              [control]="form.controls['contactIdExistingContact']"
              [itemsSource]="contacts"
              [helpText]="'RENT_APPLICATION.HELP_TEXT.EXISTING_CONTACT'"
            ></astral-typeahead>
          </astral-layout-group>
        </section>
      }
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
          @if (isNew) {
            <astral-select [control]="form.controls['contactCategory']" [itemsSource]="contactCategories"></astral-select>
          }
          @if (!isNew) {
            <astral-input [control]="form.controls['contactCustomerNumber']"></astral-input>
          }
          <astral-input [control]="form.controls['contactName']"></astral-input>
        </astral-layout-group>
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          @if (idTypes) {
            <astral-select [control]="form.controls['idType']" [itemsSource]="idTypes"></astral-select>
          }
          @if (idType) {
            <app-contact-id [idType]="idType" [control]="form.controls['contactIdentification']"></app-contact-id>
          }
          <astral-input [control]="form.controls['contactEmail']" [type]="'email'" [inputMode]="'email'"></astral-input>
          <astral-input [control]="form.controls['contactPhone']" [type]="'phone'" [inputMode]="'tel'"></astral-input>
        </astral-layout-group>
      </section>
      @if (dwellingSelected) {
        <section class="astral-section-surface astral-stack-m">
          <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
            <astral-input [control]="form.controls['numberOfRoomsMin']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
            <astral-input [control]="form.controls['numberOfRoomsMax']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
            <astral-input [control]="form.controls['maxMonthRent']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
            <astral-input [control]="form.controls['maxYearRent']" [type]="'number'" [inputMode]="'decimal'"></astral-input>
          </astral-layout-group>
        </section>
      }
      <section class="astral-section-surface astral-stack-m">
        <astral-textarea [control]="form.controls['comment']" [rows]="5"></astral-textarea>
      </section>
    </form>
  }
</section>
